export default new Map([
  ['alias', 'alias'],
  ['aliases', 'alias'],
  ['bisect', 'bisect'],
  ['build', 'build'],
  ['cert', 'certs'],
  ['certs', 'certs'],
  ['deploy', 'deploy'],
  ['dev', 'dev'],
  ['develop', 'dev'],
  ['dns', 'dns'],
  ['domain', 'domains'],
  ['domains', 'domains'],
  ['env', 'env'],
  ['git', 'git'],
  ['help', 'help'],
  ['init', 'init'],
  ['inspect', 'inspect'],
  ['link', 'link'],
  ['list', 'list'],
  ['ln', 'alias'],
  ['log', 'logs'],
  ['login', 'login'],
  ['logout', 'logout'],
  ['logs', 'logs'],
  ['ls', 'list'],
  ['project', 'project'],
  ['projects', 'project'],
  ['promote', 'promote'],
  ['pull', 'pull'],
  ['redeploy', 'redeploy'],
  ['remove', 'remove'],
  ['rm', 'remove'],
  ['rollback', 'rollback'],
  ['secret', 'secrets'],
  ['secrets', 'secrets'],
  ['switch', 'teams'],
  ['team', 'teams'],
  ['teams', 'teams'],
  ['whoami', 'whoami'],
]);
